import Icon from '../components/Icon.vue'

Icon.register({
  chess: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M74 208l-33.9-90.4c-0.6-1.5-1-4-1-5.6 0-8.8 7.2-16 16-16h0 56.9v-32h-24c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h24v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h24c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-24v32h56.9 0c8.8 0 16 7.2 16 16 0 1.6-0.5 4.1-1 5.6l-33.9 90.4h10c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-15.9c0.1 35.9 7.3 93.2 15.9 128h-128c8.7-34.8 15.8-92.1 15.9-128h-15.9c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h10zM247.2 459.6c4.9 2.4 8.8 8.9 8.8 14.3v0 22.1c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16v-22.1c0-5.5 4-11.9 8.8-14.3l23.2-11.6v-16c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v16zM339.9 301.8l-24.6-20.8c-6.3-5.3-11.3-16.2-11.4-24.4v-58.6c0-3.3 2.7-6 6-6h26.4c3.3 0 6 2.7 6 6v26h24.7v-26c0-3.3 2.7-6 6-6h53.8c3.3 0 6 2.7 6 6v26h24.7v-26c0-3.3 2.7-6 6-6h26.4c3.3 0 6 2.7 6 6v58.5 0c0 8.2-5.1 19.1-11.3 24.4l-24.6 20.8 3.3 82.2h-126.7zM384 304v32h32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zM503.2 459.6c4.9 2.4 8.8 8.9 8.8 14.3v0 22.1c0 8.8-7.2 16-16 16h-192c-8.8 0-16-7.2-16-16v-22.1c0-5.5 4-11.9 8.8-14.3l23.2-11.6v-16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess.js
// module id = 1184
// module chunks = 0